import api from "./api";

const setAuthToken = (token) => {
    if (token) {
        localStorage.removeItem("token_" + window.bo_site);
        api.defaults.headers.common["x-auth-token"] = token;
        api.defaults.headers.common["Authorization"] = "Bearer " + token;
        axios.defaults.headers.common["x-auth-token"] = token;
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        localStorage.setItem("token_" + window.bo_site, token);
    }
};

export default setAuthToken;
